import * as amplitude from '@amplitude/analytics-browser';

export const initializeAmplitude = () => {
  if (typeof window === 'undefined') return;

  try {
    amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY, {
      defaultTracking: {
        pageViews: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: true,
        sessionReplays: true,
      },
    });
    console.log('Amplitude initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Amplitude:', error);
  }
};

export const captureEvent = (eventName, eventProperties) => {
  if (typeof window === 'undefined') return;
  amplitude.track(eventName, eventProperties);
};

export const setUserId = (userId) => {
  if (typeof window === 'undefined') return;
  amplitude.setUserId(userId);
};

export const setUserProperties = (userProperties) => {
  if (typeof window === 'undefined') return;
  const identify = new amplitude.Identify();
  Object.entries(userProperties).forEach(([key, value]) => {
    identify.set(key, value);
  });
  amplitude.identify(identify);
};
